import React from 'react';
import styled from 'styled-components';
import {
  fourth
} from './howToBill';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

`;

const Row = styled.div`
  padding-left: 1rem;
`;

const ImageContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  margin-bottom: 30px;
`;

const HowToSpot = () => {
  return (
    <Container>
      <Row className="row">
        <ImageContainer className="col-md-6">
          <img
            src={fourth}
            alt="Fly Louie"
            style={{width: '80%', maxWidth: '100%'}}
          />
        </ImageContainer>
      </Row>
    </Container>
  )
}

export default HowToSpot;